import MoveTo from './behaviors/moveto/MoveTo.js';
export default MoveTo;